<template>
  <div class="changed-item clearfix">
    <not-can-edit
      :data="data"
      class="fl"
    />
    <a-button
      type="default"
      @click="handleDelete"
    >
      {{ $t('message["962"]') }}
    </a-button>
    <span class="fs-warning fl tip">{{ $t('message["332"]') }}</span>
  </div>
</template>

<script>
import NotCanEdit from './NotCanEdit'

export default {
  components: {
    NotCanEdit
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    handleDelete () {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
}
.ant-btn {
  margin-left: 16px;
}
</style>
